import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsxs("g", {
    transform: "matrix(0.05016772,0,0,0.05016772,3.2140793,3.141888)",
    children: [/*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M 210.81,37.038 H 55.599 c -11.047,0 -20,8.954 -20,20 v 155.211 c 0,11.046 8.953,20 20,20 H 210.81 c 11.045,0 20,-8.954 20,-20 V 57.038 c 0,-11.046 -8.956,-20 -20,-20 z"
    }), /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "m 454.127,37.038 h -155.21 c -11.047,0 -20,8.954 -20,20 v 155.211 c 0,11.046 8.953,20 20,20 h 155.211 c 11.045,0 20,-8.954 20,-20 V 57.038 c -10e-4,-11.046 -8.956,-20 -20.001,-20 z"
    }), /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "m 454.127,280.369 h -155.21 c -11.047,0 -20,8.954 -20,20 V 455.58 c 0,11.046 8.953,20 20,20 h 155.211 c 11.045,0 20,-8.954 20,-20 V 300.369 c -10e-4,-11.046 -8.956,-20 -20.001,-20 z"
    }), /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M 210.81,280.369 H 55.599 c -11.047,0 -20,8.954 -20,20 V 455.58 c 0,11.046 8.953,20 20,20 H 210.81 c 11.045,0 20,-8.954 20,-20 V 300.369 c 0,-11.046 -8.956,-20 -20,-20 z"
    })]
  });
});